<template>
  <div id="block-system-main" class="block block-system">
    <div class="top-banner service-banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img alt="" src="@/assets/image/banner.jpg" />
            <div class="banner-content flex flex-v">
              <div class="w">
                <h2 class="pf-medium" style="font-size: 48px">
                  服务器技术支持
                </h2>

                <p style="font-size: 16px">
                  提供适用于您的依图服务器的所有可用下载的完整列表
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainContentContainer">
      <div class="mainContent">
        <div class="mainCont-tab">
          <ul>
            <li
              v-for="item in WYMList"
              :key="item.name"
              @click="setFocusWYM(item.name)"
              :name="item.name"
            >
              <img :src="item.imgSrc" />
              <p :class="[item.name === WYMActivedName ? 'active' : null]">
                {{ item.name }}
              </p>
            </li>
          </ul>
        </div>
        <div class="mainCont-container">
          <div class="mainCont-blockHead">
            <div class="title">
              <div class="headLeftBox">
                <div class="headLeft">
                  {{ WYMActivedName }}（{{ serviceList.length }}）
                </div>
                <div class="versionBox">
                  <div class="verTitle">版本</div>
                  <el-select
                    v-model="selectedVersion"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="headRight">
                <span class="tip">*</span>
                <span>下载该文件即表示您同意</span>

                <span href="" class="downProtocol" @click="visible = true"
                  >依图软件许可协议</span
                >
                <span>的条款和条件</span>
              </div>
            </div>
            <div class="horizontalLine"></div>
          </div>
          <table class="tec-table">
            <tr class="tec-table-tr">
              <th style="width: 35%">软件名称</th>
              <th style="width: 20%">描述</th>
              <th>文件大小</th>
              <th>发布时间</th>
              <th class="downSoft">下载软件</th>
            </tr>
            <tr
              v-for="item in serviceList"
              :key="item.name"
              class="tec-table-td"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.desc }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.publish }}</td>
              <td class="downSoft">
                <a :href="item.href" target="_blank">
                  <img alt="" src="@/assets/image/fileDownload.jpg" />
                </a>
              </td>
            </tr>
          </table>
          <div class="mainCont-blockHead tecTable-margTop">
            <div class="title">
              <div class="headLeft">通用软件（{{ softList.length }}）</div>
              <div class="headRight">
                <span class="tip">*</span>
                <span
                  >以下三方软件，若需下载，请点击“下载软件”图标至第三方网站进行下载</span
                >
              </div>
            </div>
            <div class="horizontalLine"></div>
          </div>
          <table class="tec-table">
            <tr class="tec-table-tr">
              <th style="width: 35%">软件名称</th>
              <th style="width: 20%">描述</th>
              <th>文件大小</th>
              <th>发布时间</th>
              <th class="downSoft">下载软件</th>
            </tr>
            <tr v-for="item in softList" :key="item.name" class="tec-table-td">
              <td>{{ item.name }}</td>
              <td>{{ item.desc }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.publish }}</td>
              <td class="downSoft">
                <a :href="item.href" target="_blank">
                  <img alt="" src="@/assets/image/fileDownload.jpg" />
                </a>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <protocol-model :visible="visible" @closeModel="() => (visible = false)" />
  </div>
</template>

<script>
import WYMImg from '@/assets/image/WYM.jpg';
import ProtocolModel from '@/components/protocolModel.vue';
import { list, optionsList } from '@/utils/const';

export default {
  name: 'tecContent',
  components: {
    ProtocolModel
  },
  data() {
    return {
      WYMList: [
        {
          name: '2140系列服务器',
          imgSrc: WYMImg
        },
        {
          name: '2240系列服务器',
          imgSrc: WYMImg
        },
        {
          name: '2280系列服务器',
          imgSrc: WYMImg
        }
      ],
      WYMActivedName: '',
      serviceAllList: list,
      softList: [
        {
          name: 'Ubuntu 22.04',
          desc: 'Ubuntu',
          size: '1.8GB',
          publish: '2021.4.22',
          href: 'https://ubuntu.com/download/server/arm'
        },
        {
          name: 'OpenEuler 22.03',
          desc: 'OpenEuler',
          size: '--',
          publish: '2020.9.25',
          href: 'https://www.openeuler.org/zh/download/'
        },
        {
          name: 'MegaRAID 驱动',
          desc: 'RAID 存储控制器',
          size: '--',
          publish: '--',
          href: 'https://www.broadcom.com/support/download-search?pg=Storage+Adapters,+Controllers,+and+ICs&pf=RAID+Controller+Cards&pn=MegaRAID+9560-16i&pa=&po=&dk=&pl=&l=false'
        }
      ],
      visible: false,
      options: [],
      selectedVersion: '1.04'
    };
  },
  computed: {
    serviceList() {
      return this.serviceAllList.filter(
        (itm) =>
          itm.belong.includes(this.WYMActivedName) &&
          itm.version === this.selectedVersion
      );
    }
  },
  watch: {
    'WYMActivedName': function (val, oldVal) {
      if (val !== oldVal) {
        let list = optionsList.filter(item => item.belong.includes(val))
        list = list.sort((a, b) => b.id - a.id)
        this.options = list.map((item, idx) => {
          if (idx == 0) {
            return {
              value: item.value,
              label: item.label + '（Latest)'
            }
          }
          return {
            value: item.value,
            label: item.label
          }
        })
        this.selectedVersion = list[0].value
      }
    }
  },
  mounted () {
    this.WYMActivedName = '2140系列服务器'
  },
  methods: {
    setFocusWYM(name) {
      this.WYMActivedName = name;
    },
    downloadFile() {
      const link = document.createElement('a');
      link.href = this.documentSrc;
      link.setAttribute('download', '依图软件许可协议20230407.docx');

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-banner {
  margin-top: -60px;
  width: 100%;
  position: relative;
  z-index: 3;
}

.top-banner .swiper-slide {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.swiper-container {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
  padding-top: 60px;
}

.swiper-container-no-flexbox .swiper-slide {
  float: left;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform, -webkit-transform;
}

.swiper-slide img {
  width: 100%;
  float: left;
  max-width: 100%;
  height: auto;
  border: none;
}

.banner-content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 60px;
  z-index: 4;
}

.banner-content h2 {
  font-size: 48px;
  line-height: 150%;
  color: #ffffff;
  margin-bottom: 5px;
  font-size: 32px;
}

.banner-content p {
  opacity: 0.8;
  font-size: 16px;
  color: #ffffff;
  line-height: 200%;
  margin-top: 10px;
  margin-bottom: 1em;
  font-size: 14px;
  margin-bottom: 30px;
}

.banner-content p:last-of-type {
  margin-bottom: 0;
}

.w {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
}

.flex {
  display: flex;
}

.flex-v {
  flex-direction: column;
  justify-content: center;
}

.mainContentContainer {
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;
  padding-bottom: 161px;
}

.mainContent {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
}

.mainCont-tab {
}

.mainCont-tab ul {
  display: flex;
  flex-wrap: wrap;
}

.mainCont-tab ul > li {
  flex-basis: 30%;
  height: 288px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
}
.mainCont-tab ul > li:not(:first-child) {
  margin-left: 48px;
}
.mainCont-tab img {
  width: 362px;
  height: 149px;
  transform: scale(0.8);
}
.mainCont-tab p {
  border: 2px solid #b3b3b3;
  border-radius: 30px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  /* identical to box height, or 100% */

  /* $Blue/7 */

  color: #808080;
  padding: 10px 27px;
}

.mainCont-tab p.active {
  color: #0066ff;
  border-color: #0066ff;
}
.mainCont-container {
  padding: 0 50px;
  margin-top: 76px;
}
.mainCont-blockHead {
  display: flex;
  flex-direction: column;
}

.mainCont-blockHead .title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mainCont-blockHead .title .headLeftBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mainCont-blockHead .title .headLeft {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  /* identical to box height, or 100% */

  color: #000000;
}

.mainCont-blockHead .versionBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 60px;
}

.mainCont-blockHead .versionBox .verTitle {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  /* identical to box height, or 100% */

  color: #000000;
  white-space: nowrap;
  margin-right: 8px;
}

.mainCont-blockHead .versionBox .verSelect {
  width: 230px;
  height: 28px;
}

.mainCont-blockHead .title .headRight {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: #808080;
}

.mainCont-blockHead .horizontalLine {
  height: 2px;
  width: 100%;
  background: linear-gradient(90deg, #3c5cc8 0%, #6a9fdf 100%);
  margin-top: 16px;
  margin-bottom: 26px;
}

.mainCont-blockHead .headRight .tip {
  color: #e1403c;
}

.mainCont-blockHead .headRight > .downProtocol {
  color: #0066ff;
  text-decoration: underline;
  cursor: pointer;
}

.mainCont-container .tec-table {
  width: 100%;
  text-align: left;
}

.mainCont-container .tec-table .downSoft {
  text-align: center;
}

.mainCont-container .tec-table .downSoft > img {
  width: 24px;
  height: 24px;
}

.mainCont-container .tec-table th {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  /* identical to box height, or 100% */

  color: #000000;
}

.mainCont-container .tec-table td {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  /* identical to box height, or 100% */

  color: #585959;

  mix-blend-mode: normal;
  opacity: 0.9;
}

.tec-table-td > td {
  padding-top: 33px;
}

.tecTable-margTop {
  margin-top: 80px;
}
::v-deep .el-input__inner {
  height: 32px;
  width: 230px;
  border: 1px solid;
  border-radius: 6px;
  border-color: #b3b3b3 !important;
}

::v-deep .el-input {
  font-size: 16px;
}

::v-deep .el-input__icon {
  line-height: 28px;
}

::v-deep .el-select-dropdown {
  border: 1px solid #b3b3b3;
  border-radius: 6px;
  margin-top: 4px !important;
}
.el-select-dropdown__list {
  padding: 10px 0;
}

.el-select-dropdown__item {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: initial;
  color: #808080;
  margin: 0 6px;
  padding: 0px 19px;
  height: 28px;
  display: flex;
  align-items: center;
}

.el-select-dropdown__item:not(:first-of-type) {
  margin-top: 4px;
}

.el-select-dropdown__item.hover {
  background: transparent;
  /* border-radius: 6px; */
  /* color: #FFFFFF; */
}

.el-select-dropdown__item.selected {
  color: #808080;
  font-weight: 500;
  position: relative;
}

.el-select-dropdown__item.selected::before {
  content: url('/assets/image/select.png');
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 2.5px;
}
::v-deep .el-select-dropdown__item.hover {
  background: transparent;
  color: #808080;
}
.el-select-dropdown__item:hover {
  background: #0066ff;
  border-radius: 6px;
  color: #ffffff;
}

.el-select-dropdown__item.selected:hover::before {
  content: url('/assets/image/selectHover.png');
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 2.5px;
}

::v-deep .el-popper .popper__arrow {
  display: none;
}
</style>
